import { notifyMutationError } from '@inquiries/-lib/handleInquiryCompletedError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { deleteInquiryCoordination } from '@/lib'
import { queryKeys } from '@/lib/queryKeys'

export function useDeleteInquiryCoordination(inquiryId: number) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (inquiryCoordinationId: number) => {
      return deleteInquiryCoordination(inquiryId, inquiryCoordinationId)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.inquiry.coordinations(inquiryId) })
      queryClient.invalidateQueries({ queryKey: queryKeys.inquiry.actionLogs(inquiryId) })
      toast.success('調整状況を削除しました')
    },
    onError: (error: Error) => {
      notifyMutationError(error, '調整状況の削除に失敗しました')
    },
  })
}
